

export default {
    name: 'MeatPageSectionHeader',
    props: {
        title: {
            type: String,
            default: ""
        },
        description: {
            type: String,
            default: ""
        },
        variant: {
            type: String,
            default: "red"
        }
    }
}
